import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { open, close } from '../../../helpers/index';

import Facet from './Facet';

const FacetList = ({
  filterResultsLabel,
  facets,
  selectedFacets,
  onFiltersChange,
  loading
}) => {
  const breakpoint = window.matchMedia('(max-width: 1279px)');
  const filterLists = useRef(null);
  const [displayFilters, setDisplayFilters] = useState(!breakpoint.matches);

  useEffect(() => {
    const listener = () => {
      if (breakpoint.matches) {
        setDisplayFilters(false);
      } else {
        setDisplayFilters(true);
      }
    };

    breakpoint.addListener(listener);
    return () => breakpoint.removeListener(listener);
  }, []);

  useEffect(() => {
    if (displayFilters) {
      open({ element: filterLists.current, duration: 200 });
    } else {
      close({ element: filterLists.current, duration: 200 });
    }
  }, [displayFilters]);

  const updateHeight = () => {
    filterLists.current.style.height = 'auto';
  };

  return (
    <div className="facet-listing">
      {loading && <div className="loading"></div>}
      {<h3 className="facet-listing__subheading">{filterResultsLabel}</h3>}
      {facets && !loading && (
        <button
          className={
            displayFilters
              ? 'facet-listing__button facet-listing__button--expanded'
              : 'facet-listing__button'
          }
          onClick={() => setDisplayFilters(!displayFilters)}
        >
          <span>{filterResultsLabel}</span>
          <svg viewBox="0 0 32 32">
            <use xlinkHref="#filter-console-icon" />
          </svg>
        </button>
      )}
      <div
        className={
          displayFilters
            ? 'facet-listing__list-categories facet-listing__list-categories--expanded'
            : 'facet-listing__list-categories'
        }
        ref={filterLists}
      >
        {!!facets &&
          facets.map((facet, i) => (
            <Facet
              key={i}
              facet={facet}
              selected={
                selectedFacets[facet.keyword]
                  ? selectedFacets[facet.keyword]
                  : []
              }
              onFilterChange={onFiltersChange}
              onListDisplay={updateHeight}
            />
          ))}
      </div>
    </div>
  );
};

FacetList.propTypes = {
  facets: PropTypes.array,
  subTitle: PropTypes.string,
  filterResultsLabel: PropTypes.string,
  selectedFacets: PropTypes.object,
  loading: PropTypes.bool,
  onFiltersChange: PropTypes.func.isRequired
};

export default FacetList;
